// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ProjectContext } from '@/project/hooks/use-project-context';

export const ProjectProvider = ProjectContext.Provider;
